import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { cookieStorage } from "../services";

type AuthProps = {
  authToken: string | undefined;
  isLoggedIn: boolean;
  language: "ID" | "EN";
  userId: string;
  userRole: string;
  userPermission: string[];

  doLogin: (authToken: string, userId: string) => void;
  doPartialLogin: (authToken: string) => void;
  doLogout: () => void;
  setLanguage: (language: "ID" | "EN") => void;
  saveRolePermission: (role: string, permissions: string[]) => void;
};

const authStore = create<AuthProps>()(
  persist(
    (set, get): AuthProps => ({
      // states
      authToken: get()?.authToken ?? undefined,
      isLoggedIn: false,
      language: "ID",
      userId: "",
      userRole: "",
      userPermission: [],

      // actions
      doLogin: (authToken, userId) =>
        set({ isLoggedIn: true, authToken, userId }),
      doPartialLogin: (authToken) => set({ authToken }),
      doLogout: () => set({ isLoggedIn: false, authToken: undefined }),
      setLanguage: (language) => set({ language }),
      saveRolePermission: (role, permissions) =>
        set({ userRole: role, userPermission: permissions }),
    }),
    {
      name: "auth-store",
      storage: createJSONStorage(() => cookieStorage),
    }
  )
);

export default authStore;
